import { Injectable } from '@angular/core';
import MarketAvailability from '../../../types/market-availability/MarketAvailability';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class MarketAvailabilityService {

    private RESOURCE: string = 'market-availability';

    constructor(private baseService: BaseService) {
    }

    /**
     * Fetches the market availability entries for a given sample.
     *
     * @param sampleId The ID of the sample.
     * @return A list of MarketAvailability items.
     */
    public async getBySample(sampleId: number): Promise<MarketAvailability[]> {
        return await this.baseService.get<MarketAvailability[]>(`${ this.RESOURCE }/sample/${ sampleId }`);
    }
}
